import { useMediaQuery } from '@mantine/hooks';

/** Phones and small tablets: modals go full screen, side by side blocks stack. */
export function useIsMobile() {
  return useMediaQuery('(max-width: 48em)') ?? false;
}
